import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, SectionHead } from "./Reveal";
import { useSite, EASE } from "../lib/site";
import { INDUSTRY_IMAGES } from "../content";

export const Industries = () => {
  const { t } = useSite();
  const [active, setActive] = useState(0);
  return (
    <section id="industries" className="py-24 lg:py-36" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-7">
          <SectionHead id="industries" eyebrow={t.industries.eyebrow} title={t.industries.title} />
          <ul className="mt-14 border-t border-[var(--line)]">
            {t.industries.items.map((name, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <li
                  onMouseEnter={() => setActive(i)}
                  onClick={() => setActive(i)}
                  className="group flex items-center gap-5 border-b border-[var(--line)] py-5 sm:py-7 cursor-default"
                  data-testid={`industry-item-${i + 1}`}
                >
                  <img src={INDUSTRY_IMAGES[i]} alt="" className="lg:hidden h-14 w-14 shrink-0 rounded-full object-cover" />
                  <span className="f-mono text-xs text-[var(--gold)] w-8">0{i + 1}</span>
                  <span className={`f-display text-2xl sm:text-4xl transition-[color,transform] duration-500 ${active === i ? "text-[var(--paper)] lg:translate-x-3 rtl:lg:-translate-x-3" : "text-[var(--muted)]"}`}>{name}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
        <div className="hidden lg:block lg:col-span-5">
          <div className="sticky top-32 aspect-[4/5] overflow-hidden rounded-t-full border border-[var(--line-gold)]" data-testid="industry-preview">
            <AnimatePresence initial={false}>
              <motion.img
                key={active}
                src={INDUSTRY_IMAGES[active]}
                alt={t.industries.items[active]}
                initial={{ opacity: 0, scale: 1.12 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.9, ease: EASE }}
                className="absolute inset-0 h-full w-full object-cover"
              />
            </AnimatePresence>
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14]/80 to-transparent" />
            <p className="absolute bottom-6 inset-x-0 text-center f-display text-xl text-[var(--sand)]">{t.industries.items[active]}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
